import components from '@/components'
import icons from '@/icons'

export default {
  install(Vue) {
    // register local components
    Object.keys(components).forEach(name => {
      Vue.component(name, components[name])
    })

    // register svg icon
    Object.keys(icons).forEach(name => {
      Vue.component(name, icons[name])
    })
  },
}
